import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants, compose } from 'common/helpers'

import toggleOpen from 'decorators/toggleOpen'

import Modal from 'components/modal/Modal/Modal'
import UpgradeSubscriptionFlow from 'components/UpgradeSubscriptionFlow/UpgradeSubscriptionFlow'

import s from './UpgradeSubscriptionModal.scss'


class UpgradeSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.object,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.UpgradeSubscription,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)
    actions.models.upgradeSubscriptionFlow.setCurrStep(constants.upgradeSubscriptionFlowSteps.selectPlan)
    actions.models.router.removeQuery('upgrade') // show modal in the QueuePage

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const {
      name,
      data: { placement },
      isToggleActive: isCloseDisabled,
      toggleOpen: disableClose,
      toggleClose: enableClose,
    } = this.props

    return (
      <Modal
        className={s.upgradeSubscription}
        name={name}
        titleUppercase
        onClose={this.handleClose}
        disableClose={isCloseDisabled}
        disableCloseOverlay={isCloseDisabled}
      >
        <UpgradeSubscriptionFlow
          placement={placement}
          onClose={this.handleClose}
          onLoaderHide={enableClose}
          onLoaderShow={disableClose}
        />
      </Modal>
    )
  }
}


export default compose(
  toggleOpen()
)(UpgradeSubscriptionModal)
